import {Box, SxProps} from "@mui/material";

export function Content(props: { children: React.ReactNode, sx?: SxProps }) {
    return <Box sx={{ width: '100%', minHeight: '90vh', flexGrow: 1, ...props.sx }}>
        {props.children}
    </Box>
}
